import { Helmet } from 'react-helmet-async';

/**
 * WebsiteSchema — catálogo de servicios de la home.
 *
 * Organization y WebSite se emiten UNA sola vez (index.html + EnhancedOrganizationSchema),
 * por lo que aquí solo se publica el ItemList de servicios para evitar entidades
 * duplicadas/contradictorias bajo el mismo @id.
 */
const WebsiteSchema: React.FC = () => {

  const servicesSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Servicios de Punto Hispano",
    "description": "Lista completa de servicios para hispanohablantes en Suiza",
    "numberOfItems": 7,
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "item": {
          "@type": "Service",
          "name": "Gestoría y Administración",
          "description": "RAV, permisos, documentación, autónomos y empresas, contabilidad",
          "url": "https://puntohispano.ch/servicios/gestoria-administracion",
          "provider": { "@id": "https://puntohispano.ch/#organization" },
          "areaServed": { "@type": "Country", "name": "Switzerland" },
          "serviceType": "Administrative Services"
        }
      },
      {
        "@type": "ListItem",
        "position": 2,
        "item": {
          "@type": "Service",
          "name": "Asesoría Legal",
          "description": "Derecho laboral, migratorio, fiscal e impuestos",
          "url": "https://puntohispano.ch/servicios/asesoria-legal",
          "provider": { "@id": "https://puntohispano.ch/#organization" },
          "areaServed": { "@type": "Country", "name": "Switzerland" },
          "serviceType": "Legal Services"
        }
      },
      {
        "@type": "ListItem",
        "position": 3,
        "item": {
          "@type": "Service",
          "name": "Cursos de Idiomas",
          "description": "Cursos de alemán e inglés para hispanohablantes",
          "url": "https://puntohispano.ch/servicios/cursos-idiomas",
          "provider": { "@id": "https://puntohispano.ch/#organization" },
          "areaServed": { "@type": "Country", "name": "Switzerland" },
          "serviceType": "Education"
        }
      },
      {
        "@type": "ListItem",
        "position": 4,
        "item": {
          "@type": "Service",
          "name": "Consultoría de Seguros",
          "description": "Seguros obligatorios, tercer pilar, pensiones",
          "url": "https://puntohispano.ch/servicios/consultoria-seguros",
          "provider": { "@id": "https://puntohispano.ch/#organization" },
          "areaServed": { "@type": "Country", "name": "Switzerland" },
          "serviceType": "Insurance"
        }
      },
      {
        "@type": "ListItem",
        "position": 5,
        "item": {
          "@type": "Service",
          "name": "Soluciones Digitales",
          "description": "Desarrollo web, SEO, automatización, IA",
          "url": "https://puntohispano.ch/servicios/soluciones-digitales-avanzadas",
          "provider": { "@id": "https://puntohispano.ch/#organization" },
          "areaServed": { "@type": "Country", "name": "Switzerland" },
          "serviceType": "Digital Services"
        }
      },
      {
        "@type": "ListItem",
        "position": 6,
        "item": {
          "@type": "Service",
          "name": "Alquiler de Vehículos",
          "description": "Alquiler de coches flexible en Suiza",
          "url": "https://puntohispano.ch/servicios/alquileres-vehiculos",
          "provider": { "@id": "https://puntohispano.ch/#organization" },
          "areaServed": { "@type": "Country", "name": "Switzerland" },
          "serviceType": "Vehicle Rental"
        }
      },
      {
        "@type": "ListItem",
        "position": 7,
        "item": {
          "@type": "Service",
          "name": "Alquiler de Viviendas",
          "description": "Habitaciones y apartamentos en alquiler",
          "url": "https://puntohispano.ch/servicios/alquileres-viviendas",
          "provider": { "@id": "https://puntohispano.ch/#organization" },
          "areaServed": { "@type": "Country", "name": "Switzerland" },
          "serviceType": "Housing Rental"
        }
      },
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(servicesSchema)}
      </script>
    </Helmet>
  );
};

export default WebsiteSchema;